"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRingStyles = exports.useTextFillColors = exports.useTextColors = exports.useIconColors = exports.useBorderColors = exports.useBackgroundStateActiveColors = exports.useBackgroundStateColors = exports.useStrokeColors = exports.useBackgroundColors = void 0;
var SquidStyleProvider_1 = require("../SquidStyleProvider");
var branding_1 = require("./branding");
var useBackgroundColors = function (branding) {
    return useOverride(branding_1.backgroundColors, branding);
};
exports.useBackgroundColors = useBackgroundColors;
var useStrokeColors = function (branding) {
    return useOverride(branding_1.strokeColors, branding);
};
exports.useStrokeColors = useStrokeColors;
var useBackgroundStateColors = function (branding) {
    return useOverride(branding_1.backgroundStateColors, branding);
};
exports.useBackgroundStateColors = useBackgroundStateColors;
var useBackgroundStateActiveColors = function (branding) {
    return useOverride(branding_1.backgroundStateActiveColors, branding);
};
exports.useBackgroundStateActiveColors = useBackgroundStateActiveColors;
var useBorderColors = function (branding) {
    return useOverride(branding_1.borderColors, branding);
};
exports.useBorderColors = useBorderColors;
var useIconColors = function (_a) {
    var _b = _a === void 0 ? {} : _a, highlight = _b.highlight, fillBased = _b.fillBased, branding = _b.branding;
    var textBasedColors = useOverride(branding_1.iconColors, branding);
    var fillBasedColors = useOverride(branding_1.iconFillColors, branding);
    var bgColors = useOverride(branding_1.backgroundColors, branding);
    var highlightColors;
    if (highlight) {
        highlightColors = {
            disabled: bgColors.disabled,
            base: bgColors.neutral,
            accent: bgColors['accent-weak'],
            primary: bgColors['primary-weak'],
            'brand-primary': bgColors['accent-weak'],
            success: bgColors['success-weak'],
            attention: bgColors['attention-weak'],
            critical: bgColors['critical-weak'],
            info: bgColors['info-weak'],
            'on-fixed-brand': bgColors['fixed-brand'],
            'on-fixed-brand-variant': bgColors['fixed-brand-variant'],
            'on-base-active': bgColors.neutral,
            white: bgColors.neutral,
        };
    }
    return {
        colors: fillBased ? fillBasedColors : textBasedColors,
        highlightColors: highlightColors,
    };
};
exports.useIconColors = useIconColors;
var useTextColors = function (branding) {
    var merged = branding_1.textColors;
    Object.keys(branding_1.textOnColors).forEach(function (k) {
        var _a, _b;
        if (merged[k]) {
            merged = __assign(__assign({}, merged), (_a = {}, _a[k] = __assign(__assign({}, merged[k]), branding_1.textOnColors[k]), _a));
        }
        else {
            merged = __assign(__assign({}, merged), (_b = {}, _b[k] = branding_1.textOnColors[k], _b));
        }
    });
    return useOverride(merged, branding);
};
exports.useTextColors = useTextColors;
var useTextFillColors = function (branding) {
    return useOverride(branding_1.textFillColors, branding);
};
exports.useTextFillColors = useTextFillColors;
var useRingStyles = function (branding) {
    return useOverride(branding_1.ring, branding);
};
exports.useRingStyles = useRingStyles;
var useOverride = function (colors, brandingOverride) {
    var _a;
    var branding = ((0, SquidStyleProvider_1.useSquidStyles)() || {}).branding;
    var brandingColors = colors[(_a = brandingOverride !== null && brandingOverride !== void 0 ? brandingOverride : branding) !== null && _a !== void 0 ? _a : 'base'] || {};
    var baseColors = colors.base;
    return __assign(__assign({}, baseColors), brandingColors);
};
